import { CommonModule } from '@angular/common';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LibOptionValue } from 'daisy-design-system-front';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { FloatLabel } from "primeng/floatlabel"
import {ChipsModule} from "primeng/chips";
import {TranslateModule} from "@ngx-translate/core";
import {AddAsteriskIfRequiredDirective} from '../../directives/form/add-asterisk-if-required.directive';

@Component({
  selector: "app-dropdown",
  templateUrl: "./dropdown.component.html",
  styleUrls: ["./dropdown.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    MultiSelectModule,
    ReactiveFormsModule,
    SelectModule,
    FloatLabel,
    ChipsModule,
    TranslateModule,
    AddAsteriskIfRequiredDirective,
  ],
})
export class DropdownComponent<T>  {
  @Input() options: LibOptionValue<T>[] = [];
  @Input() fieldPlaceholder!: string;
  @Input() isMultiSelect = false;
  @Input() showToggleAll = false;
  @Input() valueFormControl = new FormControl();
  @Input() loading!: boolean;

  // This allows to bypass the display of "empty" in the field, if the list of options is empty
  public emptyFormControl = new FormControl([]);

  @Output() gnvValueChanges = new EventEmitter<LibOptionValue<T>>();

  handleSelectionChange(selectedOption: {originalEvent: any, value: LibOptionValue<T>}) {
    this.gnvValueChanges.emit(selectedOption.value);
  }
}
